var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
import { pageWindow } from '../../../../../domain';
/**
 * Monitoramentos compartilhados.
 *
 * As linhas e as colunas sao as MESMAS da lista de colaboradores - mesmo scope,
 * mesma view. As duas telas mostram a mesma tabela sobre populacoes diferentes: la
 * a base toda ou a empresa, aqui so quem compartilhou com este profissional.
 */
let MonitoringScope = class MonitoringScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.name = '';
        this.cpf = '';
        /** As sugestoes dos dois campos com autocompletar. */
        this.nameOptions = [];
        this.cpfOptions = [];
        this.anyFilterActive = false;
        /**
         * Conta as escritas PROGRAMATICAS nos campos de texto.
         *
         * Os campos sao nao controlados, e dois deles tem mascara - ver o
         * `formRevision` de Meus dados, que existe pelo mesmo motivo.
         */
        this.formRevision = 0;
        this.columns = [];
        this.rows = [];
        this.page = 1;
        /** Dez por pagina, como o `rowsPerPage={10}` da referencia NESTA tela. */
        this.perPage = 10;
        this.total = 0;
        this.onNameChanged = Scope.SYNC_ACTION_STRING;
        this.onCpfChanged = Scope.SYNC_ACTION_STRING;
        this.onSubmit = Scope.ASYNC_ACTION;
        this.onClearFilters = Scope.ASYNC_ACTION;
        this.onPreviousPage = Scope.ASYNC_ACTION;
        this.onNextPage = Scope.ASYNC_ACTION;
        this.onGoToPage = Scope.ASYNC_ACTION_NUMBER;
    }
    get pageCount() {
        return Math.max(1, Math.ceil(this.total / Math.max(1, this.perPage)));
    }
    /**
     * As paginas que o paginador oferece - lista pronta, e nao uma regra a aplicar.
     *
     * Deriva de `page` e `pageCount`, os dois ja observados, entao muda junto com
     * eles. Fica aqui e nao na view para que outra renderizacao so LEIA: quem desenha
     * nao precisa saber que a janela tem cinco nem que ela se centra na atual.
     */
    get pageWindow() {
        return pageWindow(this.page, this.pageCount);
    }
};
__decorate([
    observe(),
    __metadata("design:type", Function)
], MonitoringScope.prototype, "layout", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MonitoringScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MonitoringScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MonitoringScope.prototype, "cpf", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], MonitoringScope.prototype, "period", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], MonitoringScope.prototype, "cpfError", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], MonitoringScope.prototype, "nameOptions", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], MonitoringScope.prototype, "cpfOptions", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MonitoringScope.prototype, "anyFilterActive", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MonitoringScope.prototype, "formRevision", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], MonitoringScope.prototype, "columns", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], MonitoringScope.prototype, "rows", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MonitoringScope.prototype, "page", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MonitoringScope.prototype, "perPage", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MonitoringScope.prototype, "total", void 0);
MonitoringScope = __decorate([
    Observable
], MonitoringScope);
export { MonitoringScope };
//# sourceMappingURL=monitoring-list.scope.js.map